import QuillLocalStorage from 'core/utils/localStorageClient';

const LocalStorage = QuillLocalStorage.getInstance();
const getFthresh = (): number => {
  let fthresh = parseInt(LocalStorage.get('fthresh', '1'));
  if (fthresh > 3) {
    fthresh = 1;
  }
  return fthresh;
};

export const ONBOARDING_USER = Object.freeze({
  onboardingConfigSwitch: true,
  sampleInputText: [
    "QuillBot's paraphraser takes your sentences and makes changes, helping you to rework and rephrase your content quickly and efficiently!",
    "Put what you want changed in this section. Then, click the paraphrase button below. It's that easy!",
    'You can see changes to your text colored in orange, and you can make more changes by clicking on words and replacing them with synonyms. Give it a try!',
    'If you click the gear at the top right of the paraphraser, you can change various settings, such as language and visuals. You can also see text statistics and leave us feedback!',
  ],
});

const CONSTANTS = Object.freeze({
  FREE_FREEZE_WORDS_LIMIT: 1,
  DEMO_DEFAULT:
    'QuillBot will rewrite your text. Start by writing or pasting something here and then press the Paraphrase button.',
  highlightInfluentialWords: false,
  colorDifferentWords: true,
  colorStructChanges: true,
  colorLCS: true,
  displayDiff: false,
  HIGHLIGHT_WALTS: false,
  HIGHLIGHT_AUTOFLIPPED: false,
  TAG_ON_THESAURUS: 'Copy',
  TAG_ON_EDIT: 'Thesaurus',
  SUMMARIZER_CHAR_LIMIT: 2500,
  STATS_CALC_LIMIT: 10000,
  highlightLongestSubstr: null,
  QUILL_MODES_COUNT: {
    text: 'seven',
    number: 7,
  },
  premiumDialog: [25, 125, 250, 500],
  newModesDialog: [50],
  // MAX_SHOWN_COUNT_FOR_NEW_MODES_DIALOG: 1,
  STOP_WORDS: [
    'a',
    'about',
    'above',
    'according',
    'across',
    'after',
    'afterwards',
    'again',
    'against',
    'albeit',
    'all',
    'almost',
    'alone',
    'along',
    'already',
    'also',
    'although',
    'always',
    'am',
    'among',
    'amongst',
    'an',
    'and',
    'another',
    'any',
    'anybody',
    'anyhow',
    'anyone',
    'anything',
    'anyway',
    'anywhere',
    'apart',
    'are',
    'around',
    'as',
    'at',
    'av',
    'be',
    'became',
    'because',
    'become',
    'becomes',
    'becoming',
    'been',
    'before',
    'beforehand',
    'behind',
    'being',
    'below',
    'beside',
    'besides',
    'between',
    'beyond',
    'both',
    'but',
    'by',
    'can',
    'cannot',
    'canst',
    'certain',
    'cf',
    'choose',
    'contrariwise',
    'cos',
    'could',
    'cu',
    'day',
    'do',
    'does',
    "doesn't",
    'doing',
    'dost',
    'doth',
    'double',
    'down',
    'dual',
    'during',
    'each',
    'either',
    'else',
    'elsewhere',
    'enough',
    'et',
    'etc',
    'even',
    'ever',
    'every',
    'everybody',
    'everyone',
    'everything',
    'everywhere',
    'except',
    'excepted',
    'excepting',
    'exception',
    'exclude',
    'excluding',
    'exclusive',
    'far',
    'farther',
    'farthest',
    'few',
    'ff',
    'first',
    'for',
    'formerly',
    'forth',
    'forward',
    'from',
    'front',
    'further',
    'furthermore',
    'furthest',
    'get',
    'go',
    'had',
    'halves',
    'hardly',
    'has',
    'hast',
    'hath',
    'have',
    'he',
    'hence',
    'henceforth',
    'her',
    'here',
    'hereabouts',
    'hereafter',
    'hereby',
    'herein',
    'hereto',
    'hereupon',
    'hers',
    'herself',
    'him',
    'himself',
    'hindmost',
    'his',
    'hither',
    'hitherto',
    'how',
    'however',
    'howsoever',
    'i',
    'ie',
    'if',
    'in',
    'inasmuch',
    'inc',
    'include',
    'included',
    'including',
    'indeed',
    'indoors',
    'inside',
    'insomuch',
    'instead',
    'into',
    'inward',
    'inwards',
    'is',
    'it',
    'its',
    'itself',
    'just',
    'kind',
    'kg',
    'km',
    'last',
    'latter',
    'latterly',
    'less',
    'lest',
    'let',
    'like',
    'little',
    'ltd',
    'many',
    'may',
    'maybe',
    'me',
    'meantime',
    'meanwhile',
    'might',
    'moreover',
    'most',
    'mostly',
    'more',
    'mr',
    'mrs',
    'ms',
    'much',
    'must',
    'my',
    'myself',
    'namely',
    'need',
    'neither',
    'never',
    'nevertheless',
    'next',
    'no',
    'nobody',
    'none',
    'nonetheless',
    'noone',
    'nope',
    'nor',
    'not',
    'nothing',
    'notwithstanding',
    'now',
    'nowadays',
    'nowhere',
    'of',
    'off',
    'often',
    'ok',
    'on',
    'once',
    'one',
    'only',
    'onto',
    'or',
    'other',
    'others',
    'otherwise',
    'ought',
    'our',
    'ours',
    'ourselves',
    'out',
    'outside',
    'over',
    'own',
    'per',
    'perhaps',
    'plenty',
    'provide',
    'quite',
    'rather',
    'really',
    'round',
    'said',
    'sake',
    'same',
    'sang',
    'save',
    'saw',
    'see',
    'seeing',
    'seem',
    'seemed',
    'seeming',
    'seems',
    'seen',
    'seldom',
    'selves',
    'sent',
    'several',
    'shalt',
    'she',
    'should',
    'shown',
    'sideways',
    'since',
    'slept',
    'slew',
    'slung',
    'slunk',
    'smote',
    'so',
    'some',
    'somebody',
    'somehow',
    'someone',
    'something',
    'sometime',
    'sometimes',
    'somewhat',
    'somewhere',
    'spake',
    'spat',
    'spoke',
    'spoken',
    'sprang',
    'sprung',
    'stave',
    'staves',
    'still',
    'such',
    'supposing',
    'than',
    'that',
    'the',
    'thee',
    'their',
    'them',
    'themselves',
    'then',
    'thence',
    'thenceforth',
    'there',
    'thereabout',
    'thereabouts',
    'thereafter',
    'thereby',
    'therefore',
    'therein',
    'thereof',
    'thereon',
    'thereto',
    'thereupon',
    'these',
    'they',
    'this',
    'those',
    'thou',
    'though',
    'thrice',
    'through',
    'throughout',
    'thru',
    'thus',
    'thy',
    'thyself',
    'till',
    'to',
    'together',
    'too',
    'toward',
    'towards',
    'ugh',
    'unable',
    'under',
    'underneath',
    'unless',
    'unlike',
    'until',
    'up',
    'upon',
    'upward',
    'upwards',
    'us',
    'use',
    'used',
    'using',
    'very',
    'via',
    'vs',
    'want',
    'was',
    'we',
    'week',
    'well',
    'were',
    'what',
    'whatever',
    'whatsoever',
    'when',
    'whence',
    'whenever',
    'whensoever',
    'where',
    'whereabouts',
    'whereafter',
    'whereas',
    'whereat',
    'whereby',
    'wherefore',
    'wherefrom',
    'wherein',
    'whereinto',
    'whereof',
    'whereon',
    'wheresoever',
    'whereto',
    'whereunto',
    'whereupon',
    'wherever',
    'wherewith',
    'whether',
    'whew',
    'which',
    'whichever',
    'whichsoever',
    'while',
    'whilst',
    'whither',
    'who',
    'whoa',
    'whoever',
    'whole',
    'whom',
    'whomever',
    'whomsoever',
    'whose',
    'whosoever',
    'why',
    'will',
    'wilt',
    'with',
    'within',
    'without',
    'worse',
    'worst',
    'would',
    'wow',
    'ye',
    'yet',
    'year',
    'yippee',
    'you',
    'your',
    'yours',
    'yourself',
    'yourselves',
  ],
  mobileBreakPoints: [18, 35, 70], //breakpoints in vh
  modeContainerHeights: {
    header: 63,
    secondHeader: 40,
    quillBoxesInVh: 35,
    quillBoxesInVhForPremium: 35,
    quillBoxesOffsetInPx: 0,
    footer: 54,
    summaryBoxesInVh: 60,
  },
  isProgressBarOn: false,
  editableContentIdLabel: 'editable-content-within-article',
  noFlipperApplyModes: [10],
});
export const QUILL_SETTINGS: any = {
  fthresh: getFthresh(),
  hasUserInteractedWithWF: false,
  autoflip: getFthresh() !== 0,
  // useYellowToHighlightSentence:
  //   LocalStorage.get('useYellowToHighlightSentence', 'false') === 'true',
  ignoreQuotes: LocalStorage.get('ignoreQuotes', 'true') === 'true',
  USE_CONTRACTIONS: LocalStorage.get('USE_CONTRACTIONS', 'true') === 'true',
  // showLongestUnchangedWordColor: LocalStorage.get('showLongestChangeWordColor', 'true') === 'true',
  // showChangeWordColor: LocalStorage.get('showChangeWordColor', 'true') === 'true',
  // showSentenceRestructureLine: LocalStorage.get('showSentenceRestructureLine', 'true') === 'true',
};

export const SPANISH_SPEAKING_COUNTRIES = [
  'AR',
  'BO',
  'CL',
  'CO',
  'CR',
  'CU',
  'DO',
  'EC',
  'SA',
  'GQ',
  'GT',
  'HN',
  'MX',
  'NI',
  'PA',
  'PY',
  'PE',
  'ES',
  'UY',
  'VE',
  'AD',
  'BZ',
  'PH',
  'PR',
];

export const MODE_EXAMPLES_INPUT = `QuillBot is a state-of-the-art paraphrasing tool. It can completely
paraphrase an entire article for free. Simply input a sentence,
and hit the "Quill It" button.`;

export const MODE_EXAMPLES_MAP = [
  {
    INPUT: 'Shoot me an email when you get the order.',
    MODE: 'formal',
    STRENGTH: 9,
    DESCRIPTION:
      'Present text in a more professional and sophisticated way with <b>QuillBot’s Premium Modes.</b>',
    OUTPUT: `<span style="color:rgb(227, 107, 0)">Send me</span> an email <span style="color:rgb(227, 107, 0)">to confirm receipt of the products.</span>`,
    USES: [
      'Research papers/reports',
      'Essays',
      'Professional presentations',
      'Work/professional emails',
      'Cover Letters',
      'Technical and white papers',
    ],
  },
  {
    MODE: 'simple',
    STRENGTH: 10,
    DESCRIPTION:
      'Rewrite texts in a easy way, that most people can understand with <b>QuillBot’s Premium Modes.</b>',
    INPUT: 'There is no need for concern.',
    OUTPUT: `There's <span style="color:rgb(227, 107, 0)">nothing to worry about.</span>`,
    USES: [
      'Professional presentations',
      'Marketing material',
      'Website copy',
      'Breaking down complicated texts',

      'SEO titles and meta descriptions',
      'Project briefs/directions',
    ],
  },
  {
    MODE: 'creative',
    STRENGTH: 6,
    DESCRIPTION:
      'Express your ideas in a completly new and innovative way with <b>QuillBot’s Premium Modes.</b>',
    INPUT: 'It is a simple yet powerful idea.',
    OUTPUT: `The idea is <span style="color:rgb(227, 107, 0)">uncomplicated but still impactful.</span>`,
    USES: [
      'Children’s books',
      'Fiction books',
      'Non-fiction books',
      'Emails to friends',
      'Social media captions',
      'Screenwriting',
      'Blog posts',
      'Idea generation',
    ],
  },
  {
    MODE: 'expand',
    STRENGTH: 8,
    INPUT: 'Business is all about profit.',
    DESCRIPTION:
      'Add more detail and depth to increase sentence length with <b>QuillBot’s Premium Modes.</b>',
    OUTPUT: `<span style="color:rgb(227, 107, 0)">When</span> it <span style="color:rgb(227, 107, 0)">comes to</span> business, profit is <span style="color:rgb(227, 107, 0)">everything.</span>`,
    USES: [
      'Essays',
      'Research reports',
      'Descriptive writing',
      'Item descriptions',
      'Idea generation',
    ],
  },
  {
    MODE: 'shorten',
    STRENGTH: 7,
    DESCRIPTION:
      'Add more detail and depth to increase sentence length with <b>QuillBot’s Premium Modes.</b>',
    INPUT: 'People around the world observe the Christmas holiday.',
    USES: ['Professional presentations', 'Summaries', 'Marketing material'],
    OUTPUT: `Christmas is <span style="color:rgb(227, 107, 0)">celebrated everywhere.</span>`,
  },
];

export const PREMIUM_MODE_USES = [
  'Ensures text is readable and free of errors',
  'Prioritizes shortening the sentence',
  'Rewrites text in a reliable manner to maintain meaning',
  'Prioritizes changing your input above keeping the meaning',
  'Changes the sentence the most but is also the most likely to make errors',
  'Makes your text enlightened, for this very special day :D',
  'Write text in an innovative way',
  'Strips away extra words to provide a clear message',
  'Add more detail to increase sentence strength',
  'Write text in a professional way',
  'Write text in a easy and uncomplicated way',
];

export const NON_PREMIUM_MODE_STRENGTH = [0, 2];

export default CONSTANTS;
